export default "__VITE_ASSET__70b3a2ca__"